import * as React from "react";
import { SVGProps } from "react";

const AgrelloDelta = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000" {...props}>
    <rect width={2000} height={2000} fill="#322a3f" rx={28.05} />
    <path
      fill="#f4ae95"
      d="m987.84 532.7-384.53 801.76h638.38a46.23 46.23 0 0 1 42.5 28l.67 1.55a38.7 38.7 0 0 1-1.95 34.46 60.81 60.81 0 0 1-52.71 30.54H551.76a53 53 0 0 1-29.4-8.91l-3.58-2.37a53.14 53.14 0 0 1-18.31-67.23l453.72-933.68A76.89 76.89 0 0 1 974 391.49a44.45 44.45 0 0 1 56.28-.54 30.46 30.46 0 0 1 8.51 10.54L1499 1341.62a57.66 57.66 0 0 1 3.65 41.08 35.88 35.88 0 0 1-34.6 26.08h-5.27a55.39 55.39 0 0 1-50.13-31.82l-396.9-844.12a15.4 15.4 0 0 0-27.9-.14Z"
    />
  </svg>
);

export default AgrelloDelta;
